'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Fleet Caps', href: '#fleet-cap' },
    { label: 'Hospitality', href: '#hospitality' },
    { label: 'Executive', href: '#executive' },
    { label: 'Margin Math', href: '#margin-math' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        backgroundColor: scrolled ? 'rgba(5, 13, 26, 0.97)' : 'rgba(5, 13, 26, 0.95)',
        borderBottom: scrolled ? '1px solid rgba(0, 180, 255, 0.15)' : '1px solid transparent',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-3 group">
            <img
              src="/assets/images/swag_long-1784503562979.png"
              alt="Serious Swag Logo"
              className="h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="nav-link text-base"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 font-montserrat font-bold uppercase text-white border-2 rounded px-5 py-2.5 transition-all duration-300"
              style={{
                borderColor: '#ff6b35',
                backgroundColor: '#ff6b35',
                fontSize: '13px',
                letterSpacing: '0.5px',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.backgroundColor = 'transparent';
                (e.currentTarget as HTMLElement).style.color = '#ff6b35';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.backgroundColor = '#ff6b35';
                (e.currentTarget as HTMLElement).style.color = '#ffffff';
              }}
            >
              Get a Quote
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              {mobileOpen ? (
                <path d="M6 6l12 12M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              ) : (
                <>
                  <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </>
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div
            className="lg:hidden py-4 border-t"
            style={{ borderColor: 'rgba(255, 107, 53, 0.2)' }}
          >
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="block py-3 font-montserrat font-semibold text-white hover:text-accent-orange transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              className="mt-4 block text-center font-montserrat font-bold uppercase text-white border-2 rounded px-5 py-3 transition-all duration-300"
              style={{ borderColor: '#ff6b35', backgroundColor: '#ff6b35', fontSize: '13px', letterSpacing: '0.5px' }}
              onClick={() => setMobileOpen(false)}
            >
              Get a Quote
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
